export enum Environments {
  Development = 'development',
  Production = 'production',
  Earth = 'earth',
  Uranus = 'uranus',
  Staging = 'staging',
  Local = 'local',
}

export enum PaySafeEnvironments {
  Live = 'LIVE',
  Test = 'TEST',
}
